module.exports = __webpack_public_path__ + "img/favoritos.b929a616.svg";